import $ from "jquery";
import "jquery-validation";
import "jquery-validation-unobtrusive";
import "./components/vendors/bootstrap";
import "slick-carousel";

import "widgets-module/app";

window.$ = window.jQuery = $;
